/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { publishResultSchema } from '../publishSocialVideoV1/publish-social-video-v1-response';

const resendDataSchema = z.object({
  result: publishResultSchema,
});

export interface IResendSocialPostV1Data {
  result: z.infer<typeof publishResultSchema>;
}

export const resendSocialPostV1ResponseSchema = createApiResponseSchema(
  resendDataSchema,
) as z.ZodSchema<IAPI<IResendSocialPostV1Data>>;

export type IResendSocialPostV1Response = IAPI<IResendSocialPostV1Data>;
